import * as http from '../http'
import * as Types from './types'

export default class EmployeesGateway {
  uploadEmployees (query = {}) {
    return http.POSTUPLOAD(Types.UPLOAD_EMPLOYEES, query)
  }
  uploadEmployeesAppend (query = {}) {
    return http.POSTUPLOAD(Types.EMPLOYEES_UPLOAD_APPEND, query)
  }
  removeEmployeesFromTag (query = {}) {
    return http.POST(Types.EMPLOYEES_REMOVE_FROM_TAG, query)
  }

  addEmployeeWithManager (query = {}) {
    return http.POST(Types.EMPLOYEE_ADD_WITH_MANAGER, query)
  }

  removeTag (query = {}) {
    return http.POST(Types.EMPLOYEE_REMOVE_TAG, query)
  }

  assignTag (query = {}) {
    return http.POST(Types.EMPLOYEE_ASSIGN_TAG, query)
  }

  getEmployeesById (params = {}) {
    return http.GET(Types.MANAGER_EMPLOYEES_END_POINT, params)
  }

  getOrganizationEmployeesById (params = {}) {
    return http.GET(Types.ORGANIZATIONS_EMPLOYEES_END_POINT, params)
  }

  getAssignedEmployees (params = {}) {
    return http.GET(Types.EMPLOYEES_ASSIGNED, params)
  }

  getUnassignedEmployees () {
    return http.GET(Types.EMPLOYEES_UNASSIGNED)
  }

  getAllEmployees () {
    return http.GET(Types.GET_EMPLOYEES_END_POINT)
  }

  updateEmployee (query = {}) {
    return http.POST(Types.UPDATE_EMPLOYEE_END_POINT, query)
  }

  moveEmployee (query = {}) {
    return http.POST(Types.MOVE_EMPLOYEE_END_POINT, query)
  }

  deleteEmployee (query = {}) {
    return http.DELETE(Types.DELETE_EMPLOYEE_END_POINT, {}, query)
  }

  deleteEmployeeList (query = {}) {
    return http.DELETE(Types.EMPLOYEE_DELETE_LIST, {}, query)
  }

  addEmployee (query = {}) {
    return http.POST(Types.ADD_EMPLOYEE_END_POINT, query)
  }

  employeesExportExcel () {
    return http.POSTEXPORT(Types.EMPLOYEES_EXPORT_EXCEL)
  }
}



// WEBPACK FOOTER //
// ./src/api/employees/EmployeesGateway.js